import api from "@/requests";

/**
 * Запрос для полного гашения задолженности
 *
 * @param {number} amount Сумма
 */
export const redRepayment = (amount) =>
  api.post("/api/v1/MyRed/Repayment", {
    Amount: amount,
  });

/**
 * Запрос для частичного гашения задолженности
 *
 * @param {number} amount Сумма
 */
export const redPrepayment = (amount) =>
  api.post("/api/v1/MyRed/Prepayment", {
    Amount: amount,
  });
